import Box, { BoxProps } from '../ui/Box';

export type UnstyledAccordionItemLabelProps<C extends React.ElementType = 'div'> = BoxProps<C>;

const UnstyledAccordionItemLabel = ({ children, ...props }: UnstyledAccordionItemLabelProps) => {
  return <Box {...props}>{children}</Box>;
};

export default UnstyledAccordionItemLabel;
